<template>
    <div v-if="unitObject" class="unit" :class="getClasses" :style="{backgroundImage: `url(${getImage})`}" @mouseenter="mouseOn = true" @mouseleave="mouseOn = false">
        <unit-info-panel v-if="mouseOn && !unitObject.isVirtual && !selectMode() " :unitObject="unitObject"> </unit-info-panel>
    </div>
</template>

<script>
import UnitInfoPanel from './UnitInfoPanel.vue';
const config = require('../../../config');
export default {
    components: { UnitInfoPanel },
    inject: {
        selectMode: {
            type: Boolean
        }
    },
    data() {
        return {
            mouseOn: false,
        };
    },
    props: {
        unitObject: {
            type: Object,
            required: true
        },
        needsMargin: {
            type: Boolean,
            required: true
        },
    },
    computed: {
        getImage(){
            let images;
            if(config.production){
                images = require.context('/public/images/units/', false, /\.png$/);
            }
            else{
                images = require.context('/public/images/units/', false, /\.png$/);
            } 
            return images(`./${this.unitObject.id}.png`);
        },
        getClasses(){
            let classes = [`unit-team-${this.unitObject.team}`];
            if(this.needsMargin){
                classes.push('unit-pointer');
            }
            if(this.unitObject.isVirtual){
                classes.push('virtual-unit');
            }
            return classes;
        }
    }
}
</script>

<style scoped>
.unit{
    margin: 3%;
    width: 35.75px;
    height: 35.75px;
    background-size: cover;
    user-select: none;
    border-radius: 3px;
}
.virtual-unit{
    opacity: 0.6;
}
.unit-team-blue{
    box-shadow: inset 0px 0px 2px 2px var(--team-blue);
}
.unit-team-red{
    box-shadow: inset 0px 0px 2px 2px var(--team-red);
}
.unit-pointer{
    position: relative !important;
}
</style>